export default {
  cancelTokenArr: [], // 取消请求token数组
  loading_option: {},
  WorkOrderActId: '',
  ChannelActId: '',
  MoneyConfigActId:'',
  user_common_data: {},
  channel_account_wechat: {},
  merchant_account_wechat:{},
  wechat_arr: {},
  order_arr: {},
  project_arr:{}
}



// WEBPACK FOOTER //
// ./src/store/state.js